const GetApiCOC = (metodo) => {
  //produccion
  return `https://apicoc2.citymax-university.com/api/${metodo}`
}

export default GetApiCOC 